<template>
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 5L5 17M17 17L5 5.00001" stroke="black" stroke-width="2" stroke-linecap="round"/>
    </svg>
</template>

<script>

export default {
  name: 'CloseIcon'
}
</script>

<style lang="scss" scoped>
svg {
  cursor: pointer;
}

</style>
